export default "__VITE_ASSET__e37d9a85__"